import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-article-header',
  name: '图文标题区',
  icon: '题',
  group: '图文详情页',
  description: '展示标题、摘要、作者、发布时间和封面。',
  defaultProps: {
    showSummary: true,
    showCover: true,
    showPublisher: true,
    showPublishedAt: true,
    showReadCount: true
  }
}
